// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ShippingAddress = require('components/commons/shippingAddress/shippingAddress');

class HireCardPremiumPackStep4 extends React.Component {
    componentDidMount() {
        const { getInitCardsDocuments, newCardsFF } = this.props;
        newCardsFF && getInitCardsDocuments()
    }
    render() {
        const { immHireContactData, immShippingAddressList, setShippingAddress } = this.props;
        const isShippingAddressFetching = immShippingAddressList.get('shippingAddressList');
        let shippingAddressBlock = <LoadingSection />;

        if (!!isShippingAddressFetching) {
            shippingAddressBlock = (
                <ShippingAddress
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                    immHireContactData={immHireContactData}
                />
            )
        }

        return (
            <article className="row hire-card-premium-pack-step-four">
                <div className="col-sm-12">
                    {shippingAddressBlock}
                </div>
            </article>
        );
    }
}

HireCardPremiumPackStep4.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object.isRequired,
    setShippingAddress: PropTypes.func.isRequired,
};

module.exports = HireCardPremiumPackStep4;
